export const mapDataToClient = (data) => ({
  type: data.type,
  link: data.type === 'buffer' ? `data:image/jpeg;base64, ${data.link}` : data.link,
}); 
